<template>
  <div class="authnet-page">
    <header class="authnet-header">
      <img class="header-logo" :src="'/images/brand-assets/authnet-lp_logo.jpg'">
      <img class="header-image" :src="'/images/brand-assets/authnet-lp_header.jpg'">
    </header>

    <main class="credit-app-main">

      <el-dialog title="Error" :visible.sync="errors" width="30%">
        <p>{{ errors }}</p>
      </el-dialog>

      <div class="card card--form">


        <header class="card__header">
          <p>Thank you for your partnership with SAXX.<br>
            In order to proceed with making a secure Credit Card payment, please fill out the information below and will be redirected to the payment page.</p>
        </header>

        <form ref="formElement" @submit.prevent="submit" autocomplete="off">
          <section class="card__body">
            <p class="customer-info">CUSTOMER INFORMATION &nbsp<small>*Mandatory field </small></p>
            <div class="row">
              <div class="col-md-6">
                <SaxxText name="customerId" size="20" :form="formName" :hide-label="true"
                          placeholder="SAXX Customer ID*"
                          required/>
              </div>
              <div class="col-md-6">
                <p style="color: gray">*This is your account number with SAXX starting with CC or CU followed by 7 numbers (eg. CU0000123). It can be found on all your invoices and statements.</p>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <SaxxText name="email" size="255" :form="formName" :hide-label="true" placeholder="Email*"
                          required/>
              </div>
              <div class="col-md-6">
                <SaxxText name="storeName" size="50" :form="formName" :hide-label="true" placeholder="Your store name*"
                          required/>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <SaxxText name="invoiceNumber" size="20" :form="formName" :hide-label="true"
                          placeholder="Invoice number*"
                          required/>
              </div>
              <div class="col-md-6">
                <SaxxSelect
                    name="country"
                    :items="countries"
                    :form="formName"
                    :hide-label="true"
                    required
                    placeholder="Country*"
                ></SaxxSelect>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <p style="color: gray">If paying multiple invoices, please separate invoice numbers with a single space
                  (ex. 1234567 1987654)</p>
              </div>
              <div class="col-md-6">
                <button
                    class="btn btn-saxx"
                    type="submit"
                    :disabled="isLoading"
                >Submit
                </button>
              </div>
            </div>
          </section>
        </form>
      </div>
    </main>
  </div>
</template>

<script>
import Vue from "vue";
import {mapActions, mapGetters} from "vuex";
import {notify, notifyClose} from "../../utils";
import {language} from '../../lang';

import SaxxText from "../forms/SaxxText";
import SaxxSelect from "../forms/SaxxSelect";
import {ErrorlessRepository as axios} from "../../repositories/Repository";
import {VueReCaptcha} from 'vue-recaptcha-v3'



export default {
  name: "AuthorizeNetLanding",
  components: {
    SaxxSelect,
    SaxxText,
    VueReCaptcha
  },
  props: {
    lang: {
      required: false,
      type: String,
      default: "en",
    },
  },
  created() {
    this.createForm({
      name: this.formName,
      fields: {
        ...this.additionalFields,

        customerId: "",
        storeName: "",
        invoiceNumber: "",
        country: "",
        email: "",
      }
    });
  },
  data() {
    return {
      formName: "b2b.payment",
      errors: false,
      countries: [
        {"value": "ca", "label": "Canada"},
        {"value": "us", "label": "United States"}
      ],
    };
  },
  mounted() {
    Vue.use(VueReCaptcha, {siteKey: '6Lc1W3McAAAAAFVPsovPd8M9Dh-K-3LMzL3DWRIS'});
  },
  methods: {
    ...mapActions("forms", [
      "setStatus",
      "setFields",
      "setErrors",
      "setDisabledFields",
      "createForm"
    ]),
    async submit() {
      await this.$recaptchaLoaded();
      const token = await this.$recaptcha('authnet');

      if (!this.$refs.formElement.checkValidity()) {
        return this.$refs.formElement.reportValidity();
      }
      this.setErrors({
        form: this.formName,
        errors: [],
      });
      try {
        this.setStatus({
          form: this.formName,
          status: "loading"
        });

        let formdata = this.toFormData(this.fields);
        formdata.append('google', token);

        const response = await axios.post(
            `/credit-dashboard/authnet/get-link`,
            formdata,
            {
              headers: {"content-type": "multipart/form-data"}
            }
        );
        if (typeof response.data == 'undefined' || typeof response.data.status == 'undefined') {
          notify('Server error, please try again later. If you keep getting this message, please contact us.',
              'danger');
          this.setStatus({
            form: this.formName,
            status: "submitted"
          });
          return;
        }
        if (response.data.status === 0) {
          if (response.data.message.length > 0) {
            notify(response.data.message, 'danger');
            this.setStatus({
              form: this.formName,
              status: "submitted"
            });
            return;
          } else {
            notify('Error, please try again. If you keep getting this message, please contact us.', 'danger');
            this.setStatus({
              form: this.formName,
              status: "submitted"
            });
            return;
          }
        }

        window.location.href = response.data.url;
      } catch (err) {
        notify('Server error, please try again later. If you keep getting this message, please contact us.',
            'danger');
        this.setStatus({
          form: this.formName,
          status: "submitted"
        });
      }
    },
    toFormData(fields) {
      let form = new FormData();
      Object.keys(fields).forEach(key => {
        const val = fields[key];
        if (val === null) {
          return;
        }

        if (Array.isArray(val)) {
          val.forEach((v, index) => form.append(`${key}[${index}]`, v));
          return;
        }

        if (typeof val === "boolean") {
          return form.append(key, Number(val));
        }

        if (typeof val === "string" && val.trim() === "") {
          return;
        }

        form.append(key, val);
      });

      return form;
    },
  },
  computed: {
    ...mapGetters("forms", ["getStatus", "getFields"]),
    language() {
      const lang = language(this.lang);

      return lang.creditDashboard;
    },
    isSubmitted() {
      return this.getStatus({form: this.formName}) === "submitted";
    },
    isLoading() {
      return this.getStatus({form: this.formName}) === "loading";
    },
    fields() {
      return this.getFields({
        form: this.formName
      });
    },
  },
  watch: {
    isSubmitted(val) {
      if (!val) {
        return;
      }

      // notifyClose();
    }
  }
};
</script>
